<template>
    <div class="top-menu" :class="{topMenu1:!$route.meta.leftShow}">
        <div class="top-menu-content clearfix" v-if="$parent.projectType === 0">
            <img src="/static/images/logo1.png" class="logo1 fl">
            <div class="fl">
                <ul class="nav">
                    <li>
                        <router-link class="db" to='/' exact>首页</router-link>
                    </li>
                    <li>
                        <router-link class="db" to='/accountList'>清博管家</router-link>
                    </li>
                    <li>
                        <router-link class="db" to='/problem'>帮助文档</router-link>
                    </li>
                </ul>
            </div>
            <div class="fr">
                <span class="tps-na" v-if="$parent.userLevel!=20"><a href="/personalCenter/permissionComparison"><img src="../../static/images/sjvip.png" /></a></span>
                <!-- <span class="tps-na"><i class="icons tps-icon"></i>全站导航</span> -->
                <a class="warning" v-if="$parent.isSignin" target="_blank" href="https://u2.gsdata.cn/user/msglist?publish_type=3&msg_status=-1"><i class="icons warn-icon"><span></span></i></a>
                <div class="url fl" v-if="!$parent.isSignin">
                    <a class="url-a" :href="'https://u2.gsdata.cn/member/login?url='+$parent.realmName+''">登录</a><a class="url-a" :href="'https://u2.gsdata.cn/member/register?url='+$parent.realmName+''">注册</a>
                </div>
                <div class="personal-head fr" v-if="$parent.isSignin">
                    <div class="user-img fl"><img :src="$parent.vipInfo.picurl" /></div>
                    <span class="user">{{$parent.vipInfo.username}}<i class="icons up-icon"></i></span>
                    <ul class="personal-ul">
                        <li><a href="https://u2.gsdata.cn/user/index" target="_blank">账号中心</a></li>
                        <li><router-link to='/personalCenter'>我的会员</router-link></li>
                        <li><router-link to='/myDownload'>我的下载</router-link></li>
                        <li><a href="javascript:void(0);" @click="logOut();">退出登录</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 颜如玉头部 -->
        <div class="top-menu-content clearfix" v-if="$parent.projectType === 1">
            <div class="fr">
                <div class="personal-head fr" v-if="$parent.isSignin">
                    <div class="user-img fl"><img :src="$parent.vipInfo.picurl" /></div>
                    <span class="user">{{$parent.vipInfo.username}}<i class="icons up-icon"></i></span>
                    <ul class="personal-ul">
                        <li><router-link to='/personalCenter'>我的会员</router-link></li>
                        <li><router-link to='/myDownload'>我的下载</router-link></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "left",
    props: "",
    data() {
        return {
            
        }
    },
    mounted() {
        
    },
    created() {
		
    },
    methods: {// 退出登录
        logOut () {
            let that = this;
            that.$parent.loadModal(true,'正在退出登录...');
            that.$api.get('login/logout', null, r => {
                that.$parent.returnCode(r,function(){
                    location.reload();
                })
            })
        }
    }
}
</script>
<style lang="">
    
</style>



// WEBPACK FOOTER //
// src/components/topMenu.vue